var exports = {
  "Y": "xcc377c0b--9c578d--basic-info",
  "l": "xcc377c0b--9c578d--transport-accessibility",
};

module.exports = exports;
